import React from "react";
import RawRequestViewer from "./RawRequestViewer";

const v2Columns = [
  { key: "channel_id", label: "Channel ID" },
  { key: "device_id", label: "Device Box ID" },
  { key: "start", label: "Start" },
  { key: "finish", label: "Finish" },
  { key: "people", label: "People Bits" },
  { key: "data_sequence", label: "Data Sequence" },
  { key: "temp", label: "Temperature" },
  { key: "version", label: "Firmware Version" },
  { key: "server_time", label: "Server Time" },
  { key: "ts_status", label: "TS Status" },
];

const RawRequestV2 = () => (
  <RawRequestViewer
    title="Device Raw Requests (v2)"
    endpointBuilder={(deviceBoxId) => `/raw/v2/${deviceBoxId}`}
    menuKey="rawrequestsv2"
    columns={v2Columns}
    helperText="Latest 500 packets produced by the v2 firmware ingestion flow."
  />
);

export default RawRequestV2;
